import { TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Moment } from "moment";
import React, { FC } from "react";

type Props = {
	value: Moment;
	onChange: (date: Moment | null) => void;
};

export const StartFilter: FC<Props> = ({ value, onChange }) => {
	return (
		<DateTimePicker
			label="Start"
			format="MM/DD/YYYY HH:mm"
			ampm={false}
			value={value}
			onChange={(newValue) => {
				onChange(newValue);
			}}
			slotProps={{
				textField: { size: "small" },
			}}
		/>
	);
};

export const EndFilter: FC<Props> = ({ value, onChange }) => {
	return (
		<DateTimePicker
			label="End"
			format="MM/DD/YYYY HH:mm"
			ampm={false}
			value={value}
			onChange={(newValue) => {
				onChange(newValue);
			}}
			slotProps={{
				textField: { size: "small" },
			}}
		/>
	);
};
